import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-carrousel-facultades',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './carrousel-facultades.component.html',
  styleUrl: './carrousel-facultades.component.scss'
})
export class CarrouselFacultadesComponent implements OnInit {
  @Input() cards: any[] = [];
  @Input() cant: number = 4;
  @Input() data: any;
  @Input() posgrado: boolean = false;
  @Input() linkCarrers;
  isDesktop: boolean = true;
  @ViewChild('carouselWrapper') carouselWrapper!: ElementRef<HTMLElement>;
  showGrid: boolean = false;

  language: String = '';
  constructor(public route: ActivatedRoute) {
    this.route.params.forEach((params: Params) => {
      this.language = params['language'];
    });
  }
  ngOnInit(): void {
    console.log(this.data)
    if(this.posgrado){
      this.cards.push({
      path:this.data?.academicOffer?.posgradoImagen,
      pathRedirect:this.data?.academicOffer?.posgradoImagenDestacada,
      pathRedirectMobile:this.data?.academicOffer?.posgradoImagenDestacadaMobile,
      redirectCard:true,
    })
    }
  }

  goCarrers() {
    let url = this.data?.link;

    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }


  toggleView(): void {
    this.showGrid = !this.showGrid;

    // Esperamos a que Angular renderice la vista nueva y reubicamos al usuario
    // suavemente en el encabezado del componente, sin alterar el diseño.
    setTimeout(() => {
      this.carouselWrapper?.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 50);
  }

  
}
